export const BR1258EventsRecord = [
    /**
     * @event 'Click_Select_HLS'
     */
    {
        eventName: 'Click_Select_HLS',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, params } = data;
            return {
                ...params,
                params,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Click_Unselect_HLS'
     */
    {
        eventName: 'Click_Unselect_HLS',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },
    /**
     * @event 'Click_explanation'
     */
    {
        eventName: 'Click_explanation',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, params } = data;
            return {
                ...params,
                params,
                event: eventName,
            };
        },
    },
    /**
 * @event 'Click_All_Options'
 */
    {
        eventName: 'Click_All_Options',
        description: '',
        meta: [],
        scope: [],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                ...data,
                event: eventName,
            };
        },
    },

];
